import {useWindowResize} from "lib/hooks/useWindowResize";
import React from "react";

// HOC for triggering the custom legacy.ui DDIGITAL JQuery Equal heights custom event
export function withWindowResize(WrappedComponent: any) {
    return (props: any) => {
        useWindowResize();
        return <WrappedComponent {...props}></WrappedComponent>;
    }
}